export default "__VITE_ASSET__CZ0X7UpX__"